<div class="chart-container clearfix mt-3 mb-3" [ngClass]="{
    'col-6': chart.ChartContainer === 'half',
    'col-12': chart.ChartContainer === 'full'
  }">
  @if (!isEmpty(chart.Data)) {
  <div class="chart pull-left px-4" [ngClass]="{
        'col-12': chart.LegendPosition === 'bottom',
        'col-6': chart.LegendPosition === 'right'
      }">
    <highcharts-chart [Highcharts]="Highcharts" [options]="chart.Data" class="mx-auto"></highcharts-chart>
  </div>
  }

  @if (chart.Legend) {
  <div class="chart-legend px-0" [ngClass]="{
        'col-12': chart.LegendPosition === 'bottom',
        'col-6 ms-auto': chart.LegendPosition === 'right'
      }">
    @if (chart.Legend.header) {
    <table class="col-12 px-0">
      <thead>
        <tr>
          @for (th of chart.Legend.header; track th) {
          @if (th.toLowerCase() !== 'color') {
          <th>
            {{ th }}
          </th>
          }
          }
        </tr>
      </thead>
      <tbody>
        @for (tr of chart.Legend.data; track tr) {
        <tr>
          @for (
          td of tr | keyvalue: returnZero;
          track td;
          let i = $index
          ) {
          @if (chart.Legend.header[i].toLowerCase() !== 'color') {
          <td>
            @if (
            chart.Legend.header[i].toLowerCase() !== 'color' &&
            chart.Legend.header[0].toLowerCase() === 'color' &&
            i === 1
            ) {
            <span [style.background]="tr['Color']" class="indicator"></span>
            }
            {{ td.value }}
          </td>
          }
          }
        </tr>
        }
      </tbody>
    </table>
    } @else {
    @for (c of chart.Legend; track c.value) {
    <div>
      <strong>{{ c.label }}</strong> {{ c.value }}
    </div>
    }
    }
  </div>
  }
</div>